module.exports = __webpack_public_path__ + "img/Jump Casting40.80076330.jpg";